import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Typography } from '../Typography';
import styles from './PageWrapper.module.scss';

interface PageWrapperProps {
  title: string;
  dateText?: string;
  titleText: string;
  introText?: string;
  headerContainerClass?: string;
  headerSectionClass?: string;
  contentContainerClass?: string;
  children: React.ReactNode;
  aboutData: any[];
  additionalHeaderContent?: React.ReactNode;
  additionalContent?: React.ReactNode;
}

const PageWrapper: React.FC<PageWrapperProps> = ({
  dateText,
  titleText,
  introText,
  headerContainerClass = '',
  headerSectionClass = '',
  contentContainerClass = '',
  children,
  aboutData,
  additionalHeaderContent,
  additionalContent,
}) => {
  return (
    <>
      <div className={styles.pageWrapper}>
        <Header />

        <div className={`${styles.headerContainer} ${styles.pattern} ${headerContainerClass}`}>
          <section className={`${styles.headerSection} ${headerSectionClass}`}>
            {!!dateText && (
              <div className={styles.dateContainer}>
                <Typography
                  variant="text-md"
                  color="secondary"
                  weight="normal"
                  className={styles.dateText}
                >
                  {dateText}
                </Typography>
              </div>
            )}
            {!!titleText && (
              <div className={styles.titleContainer}>
                <Typography
                  variant="display-lg"
                  as="h1"
                  color="primary"
                  weight="bold"
                  className={styles.mainTitle}
                >
                  {titleText}
                </Typography>
              </div>
            )}
            {!!introText && (
              <div className={styles.introContainer}>
                <Typography
                  variant="text-xl"
                  color="secondary"
                  weight="normal"
                  className={styles.introText}
                >
                  {introText}
                </Typography>
              </div>
            )}

            {additionalHeaderContent}
          </section>
        </div>

        <main className={`${styles.contentContainer} ${contentContainerClass}`}>{children}</main>

        {additionalContent}

        <Footer aboutData={aboutData} />
      </div>
    </>
  );
};

export default PageWrapper;
